PJQ.views.toolbars = {};

PJQ.views.toolbars.BaseToolbar = PJQ.views.BaseView.extend({
	beforeFirstRender: function () {
		let $outer = _.size(this.$el) > 0 ? this.$el : $('body');
		let $toolbarsContainer = $outer.find('#toolbarsContainer');
		if (_.size($toolbarsContainer) === 0) {
			$toolbarsContainer = $('<div>', {
				id: 'toolbarsContainer'
			});
			$outer.append($toolbarsContainer);
		}
		this.setElement($toolbarsContainer);
	},
	hide: function () {
		let $animate = this.$('.toolbar');
		$animate.animate({
			height: '0px'
		}, 300, _.bind(function () {
			$animate.addClass('hidden');
		}, this));
	},
	show: function () {
		this.$('.toolbar').removeClass('hidden').animate({
			height: '50px'
		});
	},
	save: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave();
		}
	},
	close: function () {
		if (typeof this.options.onClose === 'function') {
			this.options.onClose();
		}

		let $animate = this.$('.toolbar');
		$animate.animate({
			height: '0px'
		}, 300, _.bind(function () {
			$animate.addClass('hidden');
		}, this));
	}
});

PJQ.views.toolbars.ProfileSaveToolbar = PJQ.views.toolbars.BaseToolbar.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Profile-Save'),
		hideWhenZero: true,
		onClose: null,
		onSave: null
	},
	events: {
		'click .btn-profile-save': 'save',
		'click .btn-profile-cancel-save': 'close'
	},
	afterRender: function () {
		this.workAreaCount = 0;
		setTimeout(_.bind(function () {
			this.listenTo(this.options.model, 'change', _.bind(this.renderChangedCount, this));
			this.listenTo(this.options.workAreaMap, 'update', _.bind(this.renderChangedCount, this));
			_.each(this.options.workAreaMap.models, function (model) {
				if (model) {
					this.workAreaCount += 1
				}
			}, this);
			this.groupsCount = this.options.groupSelector.getGroupsData().selected.length;
			this.renderChangedCount();
		}, this), 500)
	},
	autoShowToolbar: function () {
		this.$('.btn-profile-save, .btn-profile-cancel-save').prop('disabled', false);
		let $animate = this.$('.toolbar');
		$animate.removeClass('hidden').animate({
			height: '50px'
		});
	},
	renderChangedCount: function () {
		let profileChanged = this.options.model.hasChanged(),
			groupsChanged = this.options.groupSelector.getGroupsData().selected.length,
			newWorkCount = this.options.workAreaMap.length,
			$animate = this.$('.toolbar'),
			isHidden = $animate.hasClass('hidden');
		if (this.options.hideWhenZero && !profileChanged && !isHidden && newWorkCount === this.workAreaCount && groupsChanged === this.groupsCount || !this.options.isEdit) {
			this.$('.btn-profile-save, .btn-profile-cancel-save').prop('disabled', true);
			this.close();
		}
		else if ((isHidden && profileChanged) || (isHidden && newWorkCount !== this.workAreaCount) || (isHidden && groupsChanged !== this.groupsCount)) {
			this.$('.btn-profile-save, .btn-profile-cancel-save').prop('disabled', false);
			$animate.removeClass('hidden').animate({
				height: '50px'
			});
		}
	}
});

PJQ.views.toolbars.SettingsSaveToolbar = PJQ.views.toolbars.BaseToolbar.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Toolbar-Save'),
		validate: _.noop
	},
	events: {
		'click .btn-settings-save': 'save',
		'click .btn-settings-cancel-save': 'clearSaveModels'
	},
	beforeFirstRender: function () {
		this.saveArray = [];
	},
	renderData: function () {
		return {
			options: this.options
		};
	},
	afterRender: function () {
		this.renderToolbar();
	},
	addSaveModel: function (saveModel) {
		this.saveArray = _.reject(this.saveArray, function (md) {
			return md.cid === saveModel.cid
		});
		if (_.find(this.saveArray, function (md) {
			return md.cid === saveModel.cid;
		}) == null) {
			this.saveArray.push(saveModel);
		}
		this.renderToolbar();
	},
	clearSaveModels: function () {
		_.each(this.saveArray, function (saveModel) {
			saveModel.fetch();
		});
		this.saveArray = [];
		this.renderToolbar();
	},
	renderToolbar: function () {
		let settingsCount = _.size(this.saveArray),
			$animate = this.$('.toolbar'),
			isHidden = $animate.hasClass('hidden');
		if (settingsCount === 0 && !isHidden) {
			this.hide();
		}
		else if (isHidden && settingsCount > 0) {
			this.show();
		}
	},
	save: function () {
		let callbackCounter = 0,
			fnCallback = _.bind(function () {
				callbackCounter++;
				if (callbackCounter === _.size(this.saveArray)) {
					PJQ.notifications.notify.successNotify({
						message: 'Settings saved'
					});
					PJQ.app.session.fetch();
					this.clearSaveModels();
				}
			}, this);

		if (typeof this.options.validate !== 'function' || this.options.validate()) {
			_.each(this.saveArray, function (saveModel) {
				if (saveModel instanceof PJQ.models.users.User || saveModel instanceof PJQ.models.schedule.Settings || saveModel instanceof PJQ.models.bidForms.Settings || saveModel instanceof PJQ.models.submittals.Settings || saveModel instanceof PJQ.models.submittals.SubmittalUserSettings) {
					saveModel.save(null, {
						success: _.bind(function () {
							PJQ.app.navigator.refreshCommands();
							fnCallback();
						}, this)
					});
				}
				else if (saveModel instanceof PJQ.models.rfi.Settings) {
					saveModel.put(null, {
						success: _.bind(function () {
							fnCallback();
						}, this)
					});
				}
				else {
					saveModel.patch(null, {
						success: _.bind(function () {
							fnCallback();
						}, this)
					});
				}
			}, this);
		}
	}
});

PJQ.views.toolbars.FilesToolbar = PJQ.views.toolbars.BaseToolbar.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Toolbar-Files'),
		previewImageDimension: 160,
		hideWhenZero: true,
		isPhotos: false,
		onClose: _.noop
	},
	events: {
		'click .btn-files-download': 'download',
		'click .btn-files-share': 'share',
		'click .toolbar-close': 'close'
	},
	beforeRender: function () {
		if (this.collection == null) {
			this.collection = new PJQ.collections.files.Files(null, {
				isPhotos: this.options.isPhotos
			});
		}
		this.listenTo(this.collection, 'update', _.bind(this.renderSelectedCount, this));
	},
	renderData: function () {
		return {
			collection: this.collection,
			options: this.options
		};
	},
	afterRender: function () {
		this.renderSelectedCount();
	},
	addFiles: function (files) {
		this.collection.add(files);
	},
	removeFiles: function (files) {
		this.collection.remove(files);
	},
	renderSelectedCount: function () {
		let fileCount = _.size(this.collection.models),
			$animate = this.$('.toolbar'),
			isHidden = $animate.hasClass('hidden');
		if (this.options.hideWhenZero && fileCount === 0 && !isHidden) {
			this.close();
		}
		else if (isHidden && fileCount > 0) {
			$animate.removeClass('hidden').animate({
				height: '50px'
			});
		}
		this.$('.selected-files-label').html(fileCount.toString() + ' file' + (fileCount > 0 ? 's' : '') + ' selected');
		this.$('.download-files, .btn-share').prop('disabled', fileCount === 0);
	},
	download: function () {
		let fileCount = _.size(this.collection.models);
		if (fileCount > 1) {
			this.collection.download();
		}
		else if (fileCount === 1) {
			this.collection.models[0].download();
		}
		else {
			//todo: alert error
			//it should never get here anyway because we disable the download button when no files are selected
		}
	},
	share: function () {
		let project = PJQ.app.session.project;
		let sharingModal = new PJQ.views.sharing.SharingModal({
			project: project,
			onSave: _.bind(function (data) {
				this.collection.share(data, project, _.bind(function (share) {
					//todo: show success somehow
				}, this));
			}, this)
		});
		this.collection.share(null, project, function (share) {
			let callback = _.bind(sharingModal.urlChanged, sharingModal);
			callback(share.url);
		});
	},
	close: function () {
		this.collection.reset();
		this.options.onClose();
		let $animate = this.$('.toolbar');
		$animate.animate({
			height: '0px'
		}, 300, _.bind(function () {
			$animate.addClass('hidden');
			this.$('.selected-file-count').html(0);
		}, this));
	}
});

PJQ.views.toolbars.ExportSelectedToolbar = PJQ.views.toolbars.BaseToolbar.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Toolbar-Export-Selected'),
		previewImageDimension: 160,
		selectedCount: 0,
		onExport: null,
		onClose: null
	},
	events: {
		'click .btn-export': 'export',
		'click .toolbar-close': 'destroy'
	},
	afterRender: function () {
		this.renderSelectedCount();
		this.show();
	},
	updateSelectedCount: function (newCount) {
		this.options.selectedCount = newCount;
		this.renderSelectedCount();
	},
	renderSelectedCount: function () {
		this.$('.selected-label').html(this.options.selectedCount.toString() + ' selected');
		this.$('.btn-export').prop('disabled', this.options.selectedCount === 0);
	},
	export: function () {
		if (typeof this.options.onExport === 'function') {
			this.options.onExport();
		}
	},
	destroy: function () {
		this.hide();
		setTimeout(_.bind(function () {
			this.remove();
		}, this), 500)
	}
});
